export const STATS_REQUEST = 'STATS_REQUEST'
export const STATS_SUCCESS = 'STATS_SUCCESS'
export const STATS_REPLACE = 'STATS_REPLACE'